<template>
  <form class="intelligence-input px-3 py-3" @submit.prevent="send">
    <BaseInput
      v-model="draft"
      class="intelligence-input__field"
      type="textarea"
      autoGrow
      :rows="1"
      hideDetails
      :disabled="disabled"
      placeholder="Ask ProApp Intelligence…"
      @keydown.enter.exact.prevent="send"
    />
    <button
      class="intelligence-input__send"
      type="submit"
      aria-label="Send message"
      :disabled="disabled || !draft.trim()"
    >
      <BaseIcon icon="chat-send" color="#277FAF" width="23" height="23" />
    </button>
  </form>
</template>

<script>
export default {
  name: 'ProAppIntelligenceInput',
  props: {
    disabled: Boolean,
    resetKey: Number,
  },
  data: () => ({
    draft: '',
  }),
  watch: {
    resetKey() {
      this.draft = ''
    },
  },
  methods: {
    send() {
      const message = this.draft.trim()
      if (!message || this.disabled) return

      this.$emit('send', message)
      this.draft = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.intelligence-input {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px;
  align-items: center;
  gap: 8px;
  border-top: 1px solid var(--v-secondary-lighten3);
  background: white;

  &__field {
    min-width: 0;

    :deep() .base-input,
    :deep() .rel,
    :deep() .v-input {
      width: 100%;
    }

    :deep() .v-input__slot {
      min-height: 42px !important;
      margin: 0;
      border-radius: 10px !important;
    }

    :deep() textarea {
      max-height: 112px;
      overflow-y: auto !important;
      line-height: 1.4;
    }
  }

  &__send {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--v-primary-lighten5);
    transition: background-color 0.2s ease, opacity 0.2s ease;

    &:hover:not(:disabled),
    &:focus-visible:not(:disabled) {
      background: var(--v-primary-lighten4);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}

@media screen and (max-width: 999px) {
  .intelligence-input {
    padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;
  }
}
</style>
